import { render, staticRenderFns } from "./OrganizationTariffs.vue?vue&type=template&id=3fb9dd01"
import script from "./OrganizationTariffs.vue?vue&type=script&lang=js"
export * from "./OrganizationTariffs.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTariffs.vue?vue&type=style&index=0&id=3fb9dd01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports